const NAME_ACTION = {
	RESET: 'RESET',
	SELECT_INVOICE_ID: 'SELECT_INVOICE_ID',
	SELECT_NAME: 'SELECT_NAME',
	SELECT_OTHER: 'SELECT_OTHER',
	SET_OTHER_NAME: 'SET_OTHER_NAME',
};

const NAME_MODE = {
	INVOICE: 'invoice',
	NAME: 'name',
	OTHER: 'other',
}

function nameInitialState(isMultiMode) {
	// mode: 'invoice' | 'name' | 'other'
	return { mode: isMultiMode ? NAME_MODE.OTHER : null, name: '', invoiceId: '', otherName: '' };
}

function nameReducer(state, action) {
	switch (action.type) {
		case NAME_ACTION.SELECT_INVOICE_ID:
			return { ...state, mode: NAME_MODE.INVOICE, invoiceId: action.invoiceId, name: '', otherName: '' };
		case NAME_ACTION.SELECT_NAME:
			return { ...state, mode: NAME_MODE.NAME, name: action.name, invoiceId: '', otherName: '' };
		case NAME_ACTION.SELECT_OTHER:
			return { ...state, mode: NAME_MODE.OTHER, invoiceId: '', name: action.prefill ?? state.otherName };
		case NAME_ACTION.SET_OTHER_NAME:
			return { ...state, mode: NAME_MODE.OTHER, otherName: action.otherName, name: action.otherName, invoiceId: '' };
		case NAME_ACTION.RESET:
			return nameInitialState(action.isMultiMode);
		default:
			return state;
	}
}

export {
	NAME_ACTION,
	NAME_MODE,
	nameInitialState,
	nameReducer,
}